export default "__VITE_ASSET__x8AmB$5i__"